import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { Router } from '@angular/router';
import { Location } from '@angular/common';
import Swal from 'sweetalert2';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  lang = localStorage.getItem('language') || 'ar';
  constructor(
    private router: Router,
    public location: Location,
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        if (err.status === 429) { // Too many requests
          // debugger
          const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
          });
          Toast.fire({
            icon: "info",
            title: this.lang == 'en' ? 'Server Issue !' : 'مشكلة بالخادم !'
          });
        }
        if (err.status === 403) {
          // this.router.navigate(['/auth/notAuthorized'])

          this.router.navigate(['/auth/profile']);
          // this.authenticationService.logout();
        }
        if (err.status === 401) {
          // this.authenticationService.logout();
          // this.router.navigate(['/auth/notAuthorized']);
          localStorage.removeItem('authUser');
          localStorage.removeItem('token');
          let lang = localStorage.getItem("language")
          localStorage.clear();
          localStorage.setItem('language', lang || '');
          // this.router.navigate(['/']);
          window.location.reload();
        }

        if (err.status === 0) { // Offline
          const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
          });
          Toast.fire({
            imageUrl: '/assets/images/swal/fluent_warning-32-filled.svg',
            title: this.lang == 'en' ? 'Server Issue !' : 'مشكلة بالخادم !'
          });
          // this.snackBar.open(this.translate.instant('general.You are offline!'), this.translate.instant('swalMsg.Ok'), {
          //   horizontalPosition: 'center',
          //   verticalPosition: 'top'
          // });
        }

        // const error = err.error.message || err.statusText;
        return throwError(err.error);
      })
    );
  }
  showError(msg: string) { }
}
